import axios from 'axios';

const versionNumber = `${import.meta.env.VITE_BUILD_VERSION || '1.36'}`;
const versionTime = `${import.meta.env.VITE_BUILD_NUMBER || 'dev'}`;

const dev = {
  server: import.meta.env.VITE_API_URL,
  // server: 'http://10.151.52.15:3333/'
  versionNumber,
  versionTime,
};
const homol = {
  server: import.meta.env.VITE_API_URL,
  // server: 'http://10.151.52.15:3333/'
  versionNumber,
  versionTime,
};

const prod = {
  server: import.meta.env.VITE_API_URL,
  versionNumber,
  versionTime,
};

axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
  'token'
)}`;

const config =
  import.meta.env.VITE_STAGE === 'dev'
    ? dev
    : import.meta.env.VITE_STAGE === 'homol'
    ? homol
    : prod;

export default config;
